"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var Terminal = function Terminal(_ref) {
  var airportName = _ref.airportName,
      photo = _ref.photo,
      streetViewLink = _ref.streetViewLink,
      streetViewText = _ref.streetViewText,
      terminalName = _ref.terminalName,
      terminalInfo = _ref.terminalInfo,
      title = _ref.title,
      width = _ref.width;
  return _react["default"].createElement(_style.Container, {
    width: width
  }, _react["default"].createElement(_style.Title, null, title), _react["default"].createElement(_style.TitleNames, null, airportName), _react["default"].createElement(_style.TitleNames, null, terminalName), _react["default"].createElement(_style.TerminalInfo, {
    dangerouslySetInnerHTML: {
      __html: terminalInfo
    }
  }), _react["default"].createElement(_style.StreetViewLink, null, _react["default"].createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: streetViewLink
  }, streetViewText)), _react["default"].createElement(_style.Photo, null, _react["default"].createElement("img", {
    src: photo,
    alt: "terminal"
  })));
};

Terminal.propTypes = {
  airportName: _propTypes["default"].string,
  photo: _propTypes["default"].string,
  streetViewLink: _propTypes["default"].string,
  streetViewText: _propTypes["default"].string,
  terminalInfo: _propTypes["default"].string,
  terminalName: _propTypes["default"].string,
  title: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Terminal.defaultProps = {
  airportName: '',
  photo: '',
  streetViewLink: '',
  streetViewText: '',
  terminalInfo: '',
  terminalName: '',
  title: '',
  width: undefined
};
var _default = Terminal;
exports["default"] = _default;